import React, { useState, useEffect } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons";

import UserService from "../services/user.service";

const Home = () => {
    const [content, setContent] = useState("");

    useEffect(() => {
        UserService.getPublicContent().then(
            (response) => {
                setContent(response.data);
            },
            (error) => {
                const _content =
                    (error.response && error.response.data) ||
                    error.message ||
                    error.toString();

                setContent(_content);
            }
        );
    }, []);

    return (
        <div className="container home-content">
            {/* <header className="jumbotron"> */}
            {/* <h3>{content}</h3> */}
            <h3>
                <strong>FamilyBalance</strong> is a tool that helps you keep
                track of all the expenses and costs sustained by the members of
                your family.
            </h3>
            <hr />
            <h4>How to use it:</h4>
            <ol>
                <li>
                    Register your family and its first member by clicking the{" "}
                    <span className="badge text-bg-dark">Sign Up</span> button.
                    This member will act as the head of the family and will be
                    able to create additional members.
                </li>
                <li>
                    Add more{" "}
                    <span className="badge text-bg-dark">Family Members</span>{" "}
                    and define their cost-sharing percentage using the{" "}
                    <span className="badge text-bg-dark">Set %</span> button.
                </li>
                <li>
                    Start adding{" "}
                    <span className="badge text-bg-dark">Cost Centers</span> and{" "}
                    <span className="badge text-bg-dark">Suppliers</span>. Cost
                    centers are a type of grouping or category used to encompass
                    different suppliers.
                </li>
                <li>
                    You're almost done! Now you can register your{" "}
                    <span className="badge text-bg-dark">Payments</span> based
                    on the logged-in user. Payments can be made to either a
                    family member or a supplier.
                </li>
                <li>
                    Finally, click the{" "}
                    <span className="badge text-bg-dark">Generate Balance</span>{" "}
                    button to perform the magic{" "}
                    <FontAwesomeIcon
                        className="fontAwesomeIcon"
                        icon={faWandMagicSparkles}
                    />{" "}
                    and see the current balance between the members of your
                    family.
                </li>
            </ol>
            {/* </header> */}
        </div>
    );
};

export default Home;
